import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Trophy, Swords } from "lucide-react";
import api from "@/lib/api";

export function TopGladiators() {
  const [glads, setGlads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTopGladiators();
  }, []);

  async function loadTopGladiators() {
    try {
      console.log("[TopGladiators] Fetching top gladiators...");
      const { data } = await api.get("/alliance/top-gladiators");
      console.log("[TopGladiators] Response:", data);
      setGlads(data.gladiators || []);
    } catch (err) {
      console.error("[TopGladiators] Failed to load top gladiators:", err);
      console.error("[TopGladiators] Error response:", err.response?.data);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <section className="border border-amber-900/30 bg-zinc-950 p-5 mb-6">
        <h3 className="font-cinzel text-amber-300 uppercase tracking-wide text-sm mb-3 flex items-center gap-2">
          <Trophy size={16} /> Top Gladiators
        </h3>
        <p className="text-zinc-500 text-sm">Loading...</p>
      </section>
    );
  }

  // Always render the section, even if empty
  return (
    <section className="border border-amber-900/30 bg-zinc-950 p-3 mb-4">
      <h3 className="font-cinzel text-amber-300 uppercase tracking-wide text-xs mb-2 flex items-center gap-1.5">
        <Trophy size={14} /> Top 5 Gladiators
      </h3>
      
      {glads.length === 0 ? (
        <p className="text-zinc-500 text-xs">No gladiators found in your alliance yet.</p>
      ) : (
        <div className="grid gap-2">
          {glads.map((g, idx) => (
          <div
            key={g.id}
            className="flex items-center justify-between bg-zinc-900/40 border border-zinc-800 hover:border-amber-900/40 rounded px-3 py-2 transition-colors"
          >
            <div className="flex items-center gap-3 flex-1">
              {/* Rank Badge */}
              <div className={`flex items-center justify-center w-6 h-6 rounded-full font-bold text-[10px] ${
                idx === 0 ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30' :
                idx === 1 ? 'bg-zinc-400/20 text-zinc-300 border border-zinc-400/30' :
                idx === 2 ? 'bg-orange-700/20 text-orange-400 border border-orange-700/30' :
                'bg-zinc-800 text-zinc-500'
              }`}>
                #{g.rank}
              </div>

              {/* Gladiator Info */}
              <div className="flex-1">
                <div className="flex items-center gap-1.5">
                  <Link
                    to={`/gladiator/${g.id}`}
                    className="font-cinzel text-amber-100 hover:text-amber-400 transition-colors text-xs font-medium"
                  >
                    {g.name}
                  </Link>
                  <span className="text-[10px] text-zinc-500">· {g.class} · Rank #{g.rank}</span>
                </div>
                <div className="text-[10px] text-zinc-400">
                  <Link
                    to={`/profile/${g.owner_id}`}
                    className="text-zinc-400 hover:text-amber-400 transition-colors"
                  >
                    {g.owner_name}
                  </Link>
                </div>
              </div>

              {/* Rating */}
              <div className="text-right">
                <div className="text-xs font-semibold text-amber-400 tabular-nums">
                  {g.rating}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      )}
    </section>
  );
}
